import React from "react";
import classes from "./Image.module.css";
export default ({ src, alt, imageWrapper }) => {
  return (
    <div className={imageWrapper}>
      <img className={classes.DefaultImage} src={src} alt={alt} />
    </div>
  );
};
